module.exports = ".tab {\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n"